"use strict";

class ScrollToTop {
  constructor() {
    this.topButton = document.querySelector('.scroll-to-top').firstElementChild;
    this.footer = document.getElementById('footer');
    this.raf;
    this.events();
  }

  events() {
    this.topButton.addEventListener('click', this.scrollToTop.bind(this));
    window.addEventListener( 'scroll', this.rafScroll.bind(this) , false);
  }

  // methods
  rafScroll() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
    }

    if (this.topButton.offsetTop - window.pageYOffset < 300 ) {
        this.raf = window.requestAnimationFrame(this.showButton.bind(this));
    } else {
      this.raf = window.requestAnimationFrame(this.hideButton.bind(this));
    }

  }

  showButton() {
    this.topButton.style.opacity = '1';
  }

  hideButton() {
    this.topButton.style.opacity = '0';
  }

  scrollToTop(e) {
    window.scrollTo(0, 0);
  }

}

export default ScrollToTop;